import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'kri',
    fullName: 'Krio',
    nativeName: 'Krio',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid we nɔ gɛt wan bɔt",
    landing_title: "Sɔntin we Amazing de Kam",
    landing_subtitle: "ArgVoid na wan ap ɛn gem divɛlɔpmɛnt stɔdiɔ. Stay tuned, nyu tins de kam soon!",
    select_language: "Pik di Langwej",
    search_placeholder: "Sɔch langwej dɛn...",
    terms_title: "Tɛm dɛn fɔ di Savis",
    policy_title: "Prayvesi Polisi",
    cookies_title: "Kuki Polisi",
    terms_content: `
        <strong>1. Akseptans fɔ di Tɛm dɛn</strong><br>
        We yu akses ArgVoid, yu go gri wit dɛn Tɛm fɔ Savis ya. If dɛn nɔ gri wit dɛn tin ya, dɛn nɔ fɔ yuz di savis.<br><br>

        <strong>2. Yuz di pletfɔm</strong><br>
        ArgVoid ɛn in aplikeshɔn dɛn de "as i de" fɔ infɔmeshɔn ɛn kriyaytiv rizin dɛn. Di savis fɔ yuz nɔmɔ fɔ tin dɛn we di lɔ se.<br><br>

        <strong>3. Kɔndɔkt we dɛn nɔ gri fɔ du</strong><br>
        Fɔ yuz di sayt vulnerabilities, spam, ɔ tray fɔ akses di infrastukchɔ we dɛn nɔ alaw.<br><br>

        <strong>4. Disklɛmayshɔn</strong><br>
        Dɛn kin chenj di pletfɔm ɛn di savis dɛn ɛnitɛm we dɛn nɔ notis. Dɛn nɔ gi ɛni warranty bɔt di tɛm we di savis go wok ɔ we i go de.
    `,
    policy_content: `
        <strong>1. Infɔmeshɔn Kɔllɛkshɔn</strong><br>
        Di pletfɔm nɔ nid fɔ mek yuz ɔthɛntishɔn ɔ fɔ mek akɔn dis tɛm. No pɔsin in infɔmeshɔn (lɛk nem ɔ imel adrɛs) nɔ de aktif wan we dɛn kin gɛda frɔm di wan dɛn we kin kam fɛn wi.<br><br>

        <strong>2. Yuz Data</strong><br>
        Dɛn kin gɛda di bɛsis, anonymized analytics fɔ ɔndastand di sayt trafik ɛn fɔ mek di aplikeshɔn dɛn bɛtɛ. Dis data nɔ gɛt link to wan wan yuz aydentiti.<br><br>

        <strong>3. Tɔd-Pati Savis</strong><br>
        Dɛn kin yuz tɔd-pati prɔvayda dɛn fɔ ɔs ɛn analitiks savis. Di prayvesi prɔsis fɔ dɛn rispektiv prɔvayda dɛn ya de gayd di anonymous data we dɛn de prosɛs pan dɛn infrastukchɔ.<br><br>

        <strong>4. Data Sikyuriti</strong><br>
        Dɛn de du rizin fɔ mek dɛn protɛkt di pletfɔm. Bɔt no we fɔ transmit am na di Intanɛt nɔ de we rili sikrit.<br><br>
    `,
    cookies_content: `
        <strong>1. Wetin na Kuki ɛn Lokal Stɔrej?</strong><br>
        Kuki ɛn brawza lokal stɔrɔj na smɔl data fayl dɛn we dɛn kin kip na di divays fɔ mɛmba di kɔnfigyushɔn prɛferɛns dɛn akɔdin to di visit dɛn.<br><br>

        <strong>2. Yuz Pɔpɔshɔn</strong><br>
        Brawza LocalStorage de yuz strikt wan fɔ sev kɔnfigyushɔn sɛtin dɛn, lɛk:<br>
        - Langwej we yu lɛk<br>
        - Yuz intafeys konfigyushɔn (e.g., layout ɔ tim sɛtin)<br>
        - Temporary aplikeshɔn kesh<br><br>

        <strong>3. No Tracking</strong><br> nɔ de
        Dɛn nɔ de yuz kuki ɛn lokal stɔrɔj fɔ advatayz ɔ fɔ trak ɔda pipul dɛn. Ɔl di data we dɛn dɔn kip na strikt fɔ di kɔr funkshɔnaliti fɔ di pletfɔm.<br><br>

        <strong>4. Kontrol</strong><br> we yu de yuz
        Yu kin klia di brɔwza data ɛni tɛm tru di brawza sɛtin dɛn, we go riset ɛni lokal kɔnfigyushɔn.
    `,
    cookie_consent_text: "Wi de yuz di bɛsis kuki dɛn fɔ mek shɔ se di wɛbsayt de wok kɔrɛkt wan, lɛk fɔ kip yu sɛshɔn aktif, fɔ kip di langwej we yu lɛk, ɛn ɔda kɔstɔm kɔnfigyushɔn dɛn.",
    read_policy: "Rid di Kuki Polisi",
    support_title: "Kɔntakt Sɔpɔt",
    support_subject_label: "Tɔpik",
    support_message_label: "Mesɛj",
    support_submit_button: "Sɛnd Mɛsej",
    support_hint: "Notis: Dis go opin yu difɔlt imel aplikeshɔn fɔ sɛn di mɛsej.",
    support_success_msg: "We yu de opin yu imel ap...",
    support_error_msg: "I nɔ bin ebul fɔ sɛn mɛsej. Duya tray bak leta.",
    explorer_title: "Explorer",
    history_title: "Istri",
    animation_title: "Animɛshɔn we dɛn mek",
    config_title: "Kɔnfigyushɔn fɔ di tin dɛn we dɛn dɔn mek",
    tool_mouse: "Selekt (Ctrl+M) we yu kin pik.",
    tool_brush: "Brush (Ctrl+B) we yu de yuz.",
    tool_brush_mode: "Toggle Mode (Sɔlid/Klia) .",
    tool_eraser: "Iraza (Ctrl+E) we dɛn kin yuz.",
    tool_brush_size: "Adjɔst di Sayz fɔ di Brɔsh",
    tool_bucket: "Fil (Ctrl+F) we yu go fil.",
    tool_eyedropper: "Aydrop we de mek pɔsin in yay",
    tool_grid: "Grid (Ctrl+Shift+B) ɛn di ɔda wan dɛn.",
    tool_rotate: "Rotate (Ctrl+Shift+R) we yu kin yuz fɔ mek yu go.",
    tool_flip_h: "Flip H (Ctrl+Shift+H) .",
    tool_flip_v: "Flip V (Ctrl+Shift+V) .",
    tool_transpose: "Transpose (Ctrl+Shift+T) we yu kin yuz.",
    label_width: "Wayd",
    label_height: "Ayt",
    label_frames: "Nɔmba fɔ di Frɛm dɛn",
    label_animation: "Animɛshɔn Stayl",
    label_background_color: "Bakgrɔn Kɔlɔ",
    label_interval: "Intaval",
    tool_anim_config: "Animɛshɔn Kɔnfigyushɔn",
    label_new_width: "Nyu Width",
    label_new_height: "Nyu Ayt",
    label_apply: "Aplay",
    label_colors: "Kɔlɔ dɛn",
    label_size: "Sayz",
    label_tolerance: "Fɔ alaw",
    val_horizontal: "Bifo ɛn biɛn",
    val_vertical: "Ɔp ɛn dɔŋ",
    val_sequence: "Ɔda",
    val_bounce: "Bawns",
    val_random: "Jɔs apin",
    val_solid: "Strɔng",
    val_clear: "Klia",
    action_add_sheet: "Nyu Shit",
    action_import: "Briŋ kam",
    action_export: "Sɛn",
    action_sort_projects: "Kayn",
    sort_date_old: "Oldest Fɔs",
    sort_date_new: "Nyus Fɔs",
    sort_name_az: "Nem (A-Z) .",
    sort_name_za: "Nem (Z-A) .",
    action_new_sprite: "Nyu Sprite we dɛn kɔl",
    action_new_project: "Nyu Projɛkt",
    modal_save_all_title: "Sev Ɔl di Chenj dɛn",
    modal_save_all_desc: "Pik di prɔpati dɛn we yu want fɔ kip:",
    modal_save_selected: "Sev we dɛn dɔn pik",
    action_saved: "Dɛn dɔn sev am",
    modal_create_sprite_title: "Krio Nyu Sprite",
    modal_create_project_title: "Krio Nyu Projek",
    modal_add_sheet_title: "Ad Nyu Sheet",
    modal_rename_sheet_title: "Rinem di Sheet",
    modal_rename_sprite_title: "Rinem di nem Sprite",
    modal_delete_sprite_title: "Dilit Sprite fɔ dilit",
    modal_delete_project_title: "Dilit Projɛkt",
    modal_delete_sheet_title: "Dilit di Shit",
    placeholder_sprite_name: "Nem",
    placeholder_project_name: "Nem",
    placeholder_sheet_name: "Nem",
    placeholder_new_name: "Nyu Nem",
    action_create: "Mek",
    action_add: "Ad",
    action_rename: "Rinem di nem",
    action_duplicate: "Dupliket",
    action_delete: "Dilit",
    action_cancel: "nɔ",
    confirm_delete_sprite: "Yu shɔ se yu want fɔ dilit dis sprit?",
    confirm_delete_project: "Yu shɔ se yu want fɔ dilit dis prɔjek? Ɔl di sprit dɛn go kɔmɔt.",
    confirm_delete_sheet: "Yu shɔ se yu want fɔ dilit dis sheet?",
    err_select_sprite: "Duya, pik wan sprite fɔs.",
    err_select_project: "Duya pik wan prɔjek fɔs.",
    err_name_empty: "Nem nɔ go ebul fɔ ɛmti.",
    err_sprite_exists: "Wan sprite wit da nem de dɔn ɔlrɛdi de.",
    err_project_exists: "Wan prɔjek we gɛt da nem de dɔn ɔlrɛdi de.",
    err_no_content: "No kɔntinyu fɔ kip.",
    err_no_changes: "No chenj nɔ de fɔ sev.",
    err_delete_last_sheet: "Nɔ ebul fɔ dilit di las sheet.",
    err_extract_frames: "Nɔ bin ebul fɔ pul ɛni freym.",
    err_indexeddb: "Failed fɔ sev lokal wan. Sɔntɛm yu brɔwza nɔ go sɔpɔt IndexedDB.",
    msg_upload_success: "Uplod Saksesful: {0}",
    msg_upload_failed: "Uplod Failed: {0} we yu dɔn ɔplod.",
    msg_save_success: "Sev saksesful.",
    msg_saving: "We yu de sev...",
    msg_multi_save_result: "Sev {0} asɛt dɛn. {1} di tin dɛn we nɔ ebul fɔ du.",
    menu_title: "Menyu we de na di menyu",
    menu_save: "Sev",
    menu_save_all: "Sev Ɔlman",
    menu_support: "Kɔntakt Sɔpɔt",
    label_local_storage: "Lokal Stɔrej",
    label_sign_in: "Sayn In insay",
    modal_export_title: "Ɛkspɔt Sprite",
    label_filename: "Fayl nem",
    label_format: "Fɔmat",
    action_export_confirm: "Sɛn",
};

export default translations;
